import React from 'react';

import { Badge } from '@/components/badge';

export interface PlanItemInclusionProps {
  text: string;
  limitText?: string;
}

const PlanItemInclusion = ({ text, limitText }: PlanItemInclusionProps) => {
  if (!text) return null;

  return (
    <span>
      {text} {limitText && <Badge>{limitText}</Badge>}
    </span>
  );
};

export { PlanItemInclusion };
